const updateGameOver = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const {
            gameData: {
                status: {
                    statusCode,
                    abstractGameCode
                } = {},
                teams = {}
            } = {},
            liveData: {
                linescore: {
                    currentInning,
                    scheduledInnings,
                    inningState,
                    teams: {
                        away: {
                            runs: runsAway,
                            isWinner: awayIsWinner
                        } = {},
                        home: {
                            runs: runsHome,
                            isWinner: homeIsWinner
                        } = {}
                    } = {}
                } = {}
            } = {}
        } = action?.data || {};

        return {
            ...state,
            statusCode,
            abstractGameCode,
            runsAway,
            runsHome,
            awayIsWinner,
            homeIsWinner,
            teams,
            currentInning,
            scheduledInnings,
            inningState
        }
    }
    if (type === 'dataEngine_update_response' && datasource === 'schedule') {
        const {xrefIds} = action?.data || {};
        const xrefId = xrefIds?.find(xref => xref.xrefType='game_non_game');
        return {
            ...state,
            xrefId
        }
    }
    if (type === 'dataEngine_update_response' && datasource === 'ruleSettings') {
        const {ruleSettings} = action?.data || {};
        const tiebreakerScenario = ruleSettings?.find(rule => rule?.settingId === 38 && rule?.settingName === 'tiebreakerScenario');
        return {
            ...state,
            tiebreakerScenario
        }
    }

    return state;
};

export default updateGameOver;
